/**
 * Created by mateimisarca on 17/09/2020
 */

const updateObject = (oldObj, ...rest) => Object.assign({}, oldObj, ...rest);

export default updateObject;
